import { useEffect, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import Close from '@mui/icons-material/Close';
import Info from '@mui/icons-material/Info';
import { alpha, useTheme } from '@mui/material/styles';

const STORAGE_KEY = 'cc-demo-banner-dismissed';

export const DemoBanner: React.FC = () => {
  const theme = useTheme();
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    setDismissed(window.localStorage.getItem(STORAGE_KEY) === '1');
  }, []);

  if (dismissed) return null;

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  return (
    <Box
      role="status"
      sx={{
        bgcolor: alpha(theme.palette.warning.main, 0.12),
        borderBottom: `1px solid ${alpha(theme.palette.warning.main, 0.45)}`,
        color: theme.palette.warning.dark,
        px: { xs: 1.5, sm: 2.5 },
        py: 0.875,
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
      }}
    >
      <Info sx={{ fontSize: 18, flexShrink: 0 }} />
      <Typography variant="body2" sx={{ fontWeight: 500, flex: 1, lineHeight: 1.4 }}>
        <Box component="span" sx={{ fontWeight: 700 }}>Demo environment.</Box>{' '}
        You're viewing a simulation of ClearCollect — data is sample-only and actions don't persist beyond your browser session.
      </Typography>
      <IconButton
        size="small"
        onClick={dismiss}
        aria-label="Dismiss demo notice"
        sx={{ color: 'inherit', flexShrink: 0 }}
      >
        <Close fontSize="small" />
      </IconButton>
    </Box>
  );
};
